import React, {useState} from 'react';
import {Upload} from 'antd';
import {UploadFile, UploadChangeParam, RcFile} from 'antd/lib/upload/interface';
import {PaperClipOutlined, PictureOutlined} from '@ant-design/icons';
import {getQiniuUploadTokenSource} from 'Services/common';
import Config from 'config';

interface UploadProps {
    type: uploadType;
    onUpload?: (info: UploadChangeParam<UploadFile<any>>) => void;
}

const uploadUrl = Config.QiNiuUploadUrl;
const uploadName = 'file';

export enum uploadType {
    File,
    Image,
}

const UploadComponent: React.FC<UploadProps> = ({type, onUpload}) => {
    const [token, setToken] = useState('');

    const beforeUpload = async (file: RcFile) => {
        const token = await getQiniuUploadTokenSource();
        setToken(token);
        return file;
    };

    return (
        <Upload
            accept={type === uploadType.File ? '' : 'image/*'}
            action={uploadUrl}
            data={{token}}
            name={uploadName}
            showUploadList={false}
            beforeUpload={beforeUpload}
            onChange={onUpload}>
            <button
                type="button"
                className="control-item button upload-button"
                data-title={type === uploadType.File ? '上传附件' : '上传图片'}>
                {type === uploadType.File && <PaperClipOutlined />}
                {type === uploadType.Image && <PictureOutlined />}
            </button>
        </Upload>
    );
};

export default UploadComponent;
